// thunk.js

import { loginSuccess, loginfailure, logout } from "./reducer";
import axios from "axios";
import toast from "react-hot-toast";
import _BaseAPIService from "../../../Services/_BaseAPIService";

const apiUrl = window.APP_CONFIG.baseapi + "/api/auth/login";

export const login = (credentials, history) => async (dispatch) => {
  try {
    // Make the API request to perform the login operation.
    console.log(login);
    console.log(credentials);
    const response = await axios.post(apiUrl, credentials);
    const user = response;
    if (user) {
      // Check if there is data in the response
      // Extract the user data from the response data.

      // Store the user data and token in local storage.
      _BaseAPIService.storeToken(user.accessToken);
      localStorage.setItem("user", JSON.stringify(user)); // Use JSON.stringify to store an object as a string
      localStorage.setItem("token", user.accessToken);

      // Dispatch the login success action with the user data.

      // dispatch(loginSuccess(user));
      // console.log("reached user");
      // history("/Dashboard");
      // toast.success("Welcome! ");

      // Check if user role is BillingUser, and navigate accordingly
      const userRole = user.user && user.user.roles ? user.user.roles[0] : null;
      // Navigate based on user role
      if (userRole === "BillingUser" || userRole === "Waiter") {
        history("/organization-pos");
        toast.success("Welcome to Organization POS!");
      } else if (userRole === "SuperAdmin") {
        history("/dashboard");
        toast.success("Welcome, SuperAdmin!");
      } else {
        history("/org-dashboard");
        toast.success("Welcome!");
      }
    } else {
      dispatch(loginfailure());
      toast.error("Invalid username or password. Please try again.");
    }
  } catch (error) {
    dispatch(loginfailure());
    toast.error("Invalid username or password. Please try again.");
  }
};

export const logoutUser = () => (dispatch) => {
  // Clear the user data and token from local storage.
  localStorage.removeItem("user");
  localStorage.removeItem("token");

  // Dispatch the logout action.
  dispatch(logout());
};
